import { type RouteObject } from 'react-router-dom';

import { GUIDE_PATH } from '../features/knowledge-base/utils/guideUrls';

// Public siblings of the authenticated routes; shared providers supply the app theme and store.
export const knowledgeBaseRoutes: RouteObject[] = [
  {
    path: `${GUIDE_PATH}/:slug?`,
    async lazy() {
      const { KnowledgeBasePage } = await import('@features/knowledge-base');
      return { Component: KnowledgeBasePage };
    },
  },
];
